import store from '../../../../store';
import { REGISTER_WITH_EMAIL, REGISTER_WITH_MOBILE } from '../../../../utils/constants';

const EMAIL_LISTING_ROUTE = '/portal/nct/change-email-list';
const EMAIL_ENTER_ROUTE = '/portal/nct/change-email';
const EMAIL_OTP_VERIFY = '/portal/nct/change-email-otp';
const REGISTERED_EMAIL_OR_PHONE_VERIFY = '/portal/nct/change-email-auth';

export const SUCCESS = 'SUCCESS';

export const CHANGE_EMAIL_LOGIN_FLOW = [
    EMAIL_LISTING_ROUTE,
    REGISTERED_EMAIL_OR_PHONE_VERIFY,
    EMAIL_ENTER_ROUTE,
    EMAIL_OTP_VERIFY,
];
export const CHANGE_EMAIL_MOBILE_LOGIN_FLOW = [
    EMAIL_ENTER_ROUTE,
    EMAIL_OTP_VERIFY,
    EMAIL_LISTING_ROUTE,
    REGISTERED_EMAIL_OR_PHONE_VERIFY,
];

export function getChangeEmailFlow(registerType = REGISTER_WITH_MOBILE) {
    return registerType === REGISTER_WITH_EMAIL
        ? CHANGE_EMAIL_LOGIN_FLOW
        : CHANGE_EMAIL_MOBILE_LOGIN_FLOW;
}
